import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addBlock: {
    id: 'Add block…',
    defaultMessage: 'Add block…',
  },
  required: {
    id: 'Required input is missing.',
    defaultMessage: 'Required input is missing.',
  },
  minLength: {
    id: 'Minimum length is {len}.',
    defaultMessage: 'Minimum length is {len}.',
  },
  maxLength: {
    id: 'Maximum length is {len}.',
    defaultMessage: 'Maximum length is {len}.',
  },
  minimum: {
    id: 'Minimum value is {len}.',
    defaultMessage: 'Minimum value is {len}.',
  },
  maximum: {
    id: 'Maximum value is {len}.',
    defaultMessage: 'Maximum value is {len}.',
  },
  uniqueItems: {
    id: 'Items must be unique.',
    defaultMessage: 'Items must be unique.',
  },
  save: {
    id: 'Save',
    defaultMessage: 'Save',
  },
  saved: {
    id: 'Saved',
    defaultMessage: 'Saved',
  },
  isNumber: {
    id: 'number',
    defaultMessage: 'Input must be number',
  },
  isInteger: {
    id: 'integer',
    defaultMessage: 'Input must be integer',
  },
  isValidEmail: {
    id: 'email',
    defaultMessage: 'Input must be valid email (something@domain.com)',
  },
  isValidURL: {
    id: 'url',
    defaultMessage:
      'Input must be valid url (www.something.com or http(s)://www.something.com)',
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel',
  },
  error: {
    id: 'Error',
    defaultMessage: 'Error',
  },
  thereWereSomeErrors: {
    id: 'There were some errors.',
    defaultMessage: 'There were some errors.',
  },
  searchUsers: {
    id: 'Search users…',
    defaultMessage: 'Search users…',
  },
  searchGroups: {
    id: 'Search group…',
    defaultMessage: 'Search group…',
  },
  filterByGroups: {
    id: 'Filter users by groups',
    defaultMessage: 'Filter users by groups',
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
  deleteUserConfirmTitle: {
    id: 'Delete User',
    defaultMessage: 'Delete User',
  },
  deleteGroupConfirmTitle: {
    id: 'Delete Group',
    defaultMessage: 'Delete Group',
  },
  add: {
    id: 'Add',
    defaultMessage: 'Add',
  },
  addUserButtonTitle: {
    id: 'Add new user',
    defaultMessage: 'Add new user',
  },
  addGroupsButtonTitle: {
    id: 'Add new group',
    defaultMessage: 'Add new group',
  },
  addUserFormTitle: {
    id: 'Add User',
    defaultMessage: 'Add User',
  },
  addGroupsFormTitle: {
    id: 'Add group',
    defaultMessage: 'Add group',
  },
  groupDeleted: {
    id: 'Group deleted',
    defaultMessage: 'Group deleted',
  },
  addUserFormUsernameTitle: {
    id: 'Username',
    defaultMessage: 'Username',
  },
  addUserFormUsernameDescription: {
    id: 'addUserFormUsernameDescription',
    defaultMessage:
      'Enter a user name, usually something like "jsmith". No spaces or special characters. Usernames and passwords are case sensitive, make sure the caps lock key is not enabled. This is the name used to log in.',
  },
  addUserFormFullnameDescription: {
    id: 'addUserFormFullnameDescription',
    defaultMessage: 'Enter full name, e.g. John Smith.',
  },
  addUserFormEmailDescription: {
    id: 'addUserFormEmailDescription',
    defaultMessage:
      'Enter an email address. This is necessary in case the password is lost. We respect your privacy, and will not give the address away to any third parties or expose it anywhere.',
  },
  addUserFormPasswordDescription: {
    id: 'addUserFormPasswordDescription',
    defaultMessage: 'Enter your new password. Minimum 8 characters.',
  },
  addGroupsFormTitleTitle: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  addUserFormFullnameTitle: {
    id: 'Fullname',
    defaultMessage: 'Fullname',
  },
  addUserGroupNameTitle: {
    id: 'Add to Groups',
    defaultMessage: 'Add to Groups',
  },
  addGroupsFormGroupNameTitle: {
    id: 'Groupname',
    defaultMessage: 'Groupname',
  },
  addGroupsFormDescriptionTitle: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  addUserFormEmailTitle: {
    id: 'Email',
    defaultMessage: 'Email',
  },
  addGroupsFormEmailTitle: {
    id: 'Email',
    defaultMessage: 'Email',
  },
  addUserFormPasswordTitle: {
    id: 'Password',
    defaultMessage: 'Password',
  },
  addUserFormSendPasswordResetTitle: {
    id: 'Send a confirmation mail with a link to set the password.',
    defaultMessage: 'Send a confirmation mail with a link to set the password.',
  },
  addUserFormRolesTitle: {
    id: 'Roles',
    defaultMessage: 'Roles',
  },
  addUserFormPasswordAndSendPasswordTogetherNotAllowed: {
    id: 'It is not allowed to define both the password and to request sending the password reset message by e-mail. You need to select one of them.',
    defaultMessage:
      'It is not allowed to define both the password and to request sending the password reset message by e-mail. You need to select one of them.',
  },
  userSearchNoResults: {
    id: 'There are no users with the searched criteria',
    defaultMessage: 'There are no users with the searched criteria',
  },
  groupSearchNoResults: {
    id: 'There are no groups with the searched criteria',
    defaultMessage: 'There are no groups with the searched criteria',
  },
  updateUserFormTitle: {
    id: 'Update User',
    defaultMessage: 'Update User',
  },
  updateUserSuccess: {
    id: 'User updated successfuly',
    defaultMessage: 'User updated successfuly',
  },
  updateRoles: {
    id: 'User roles updated',
    defaultMessage: 'User roles updated',
  },
  updateGroups: {
    id: 'Group roles updated',
    defaultMessage: 'Group roles updated',
  },
  addGroupsFormRolesTitle: {
    id: 'Roles',
    defaultMessage: 'Roles',
  },
  success: {
    id: 'Success',
    defaultMessage: 'Success',
  },
  userCreated: {
    id: 'User created',
    defaultMessage: 'User created',
  },
  userDeleted: {
    id: 'User deleted',
    defaultMessage: 'User deleted',
  },
  groupCreated: {
    id: 'Group created',
    defaultMessage: 'Group created',
  },
  users: {
    id: 'Users',
    defaultMessage: 'Users',
  },
  usergroup: {
    id: 'User Group Settings',
    defaultMessage: 'User Group Settings',
  },
  usergroupmemberbership: {
    id: 'User Group Membership',
    defaultMessage: 'User Group Membership',
  },
  membershipUpdated: {
    id: 'Membership updated',
    defaultMessage: 'Membership updated',
  },
  noUserFound: {
    id: 'No user found',
    defaultMessage: 'No user found',
  },
  pleaseSearchOrFilterUsers: {
    id: 'Please search for users or use the filters on the side.',
    defaultMessage: 'Please search for users or use the filters on the side.',
  },
  addUsersToGroup: {
    id: 'Add users to group',
    defaultMessage: 'Add users to group',
  },
  removeUsersFromGroup: {
    id: 'Remove users from group',
    defaultMessage: 'Remove users from group',
  },
  groups: {
    id: 'Groups',
    defaultMessage: 'Groups',
  },
  copyBlocks: {
    id: 'Copy blocks',
    defaultMessage: 'Copy blocks',
  },
  cutBlocks: {
    id: 'Cut blocks',
    defaultMessage: 'Cut blocks',
  },
  pasteBlocks: {
    id: 'Paste blocks',
    defaultMessage: 'Paste blocks',
  },
  deleteBlocks: {
    id: 'Delete blocks',
    defaultMessage: 'Delete blocks',
  },
  showAllUserButton: {
    id: 'Show All',
    defaultMessage: 'Show All',
  },
  showAllUserText: {
    id: "Enter a username above to search or click 'Show All'",
    defaultMessage: "Enter a username above to search or click 'Show All'",
  },
  addJoinedGroups: {
    id: 'Show groups of users below',
    defaultMessage: 'Show groups of users below',
  },
  urlClipboardCopy: {
    id: 'Link copied to clipboard',
    defaultMessage: 'Anchor link copied to the clipboard',
  },
  inspectRelations: {
    id: 'Inspect relations',
    defaultMessage: 'Inspect relations',
  },
  relations: {
    id: 'Relations',
    defaultMessage: 'Relations',
  },
  fixRelations: {
    id: 'Fix relations',
    defaultMessage: 'Fix relations',
  },
  searchRelationSource: {
    id: 'Search sources by title or path',
    defaultMessage: 'Search sources by title or path',
  },
  searchRelationTarget: {
    id: 'Search targets by title or path',
    defaultMessage: 'Search targets by title or path',
  },
  createOrDeleteRelationsToTarget: {
    id: 'Create or delete relations to target',
    defaultMessage: 'Create or delete relations to target',
  },
  relationName: {
    id: 'Relation name',
    defaultMessage: 'relation',
  },
  selectRelation: {
    id: 'Select relation',
    defaultMessage: 'Select relation',
  },
  norelationfound: {
    id: 'No relation found',
    defaultMessage: 'No relation found',
  },
  toomanyrelationsfound: {
    id: 'Many relations found. Please search.',
    defaultMessage: 'Many relations found. Please search.',
  },
  rebuildRelations: {
    id: 'rebuild relations',
    defaultMessage: 'rebuild relations',
  },
  flushAndRebuildRelations: {
    id: 'flush intIds and rebuild relations',
    defaultMessage: 'flush intIds and rebuild relations',
  },
  flushAndRebuildRelationsHints: {
    id: 'flushAndRebuildRelationsHints',
    defaultMessage:
      '<ul><li>Regenerate intIds (tokens of relations in relation catalog)</li><li>Rebuild relations</li></ul><p>Check the log for details!</p><p><b>Warning</b>: If you have add-ons relying on intIds, you should not flush them.</p>',
  },

  addPotentialTargetsPath: {
    id: 'target path',
    defaultMessage: 'target path',
  },
  addPotentialSourcesPath: {
    id: 'sources path',
    defaultMessage: 'sources path',
  },
  relationsUpdated: {
    id: 'Relations updated',
    defaultMessage: 'Relations updated',
  },
  select: {
    id: 'Select',
    defaultMessage: 'Select',
  },
  selected: {
    id: 'Selected',
    defaultMessage: 'Selected',
  },
  filter: {
    id: 'Filter',
    defaultMessage: 'Filter',
  },
  fileTooLarge: {
    id: 'fileTooLarge',
    defaultMessage: 'This website does not accept files larger than {limit}',
  },
  blocksFieldsErrorTitle: {
    id: 'blocksFieldsErrorTitle',
    defaultMessage: 'Error in the block field {errorField}.',
  },
  startEventRange: {
    id: 'Event start date must be on or before {endDateValueOrEndFieldName}',
    defaultMessage:
      'Event start date must be on or before {endDateValueOrEndFieldName}',
  },
  endEventRange: {
    id: 'Event end date must be on or after {startDateValueOrStartFieldName}',
    defaultMessage:
      'Event end date must be on or after {startDateValueOrStartFieldName}',
  },
  pattern: {
    id: 'The value does not match the pattern {pattern}',
    defaultMessage: 'The value does not match the pattern {pattern}',
  },
  maxItems: {
    id: 'The number of items must be less than or equal to {maxItems}',
    defaultMessage:
      'The number of items must be less than or equal to {maxItems}',
  },
  minItems: {
    id: 'The number of items must be greater than or equal to {minItems}',
    defaultMessage:
      'The number of items must be greater than or equal to {minItems}',
  },
  defaultLanguage: {
    id: "The selected default language must be in the list of the field 'Available languages'",
    defaultMessage:
      "The selected default language must be in the list of the field 'Available languages'",
  },
});
